<template>
  <MessageBanner type="info" class="mt-10 mb-4 !border-primary-subtle">
    <template #icon>
      <img :src="bannerImage" class="w-[208px]" />
    </template>

    <template #action>
      <a
        class="btn-primary-color-s shrink-0 whitespace-nowrap"
        :href="ctaLink"
        target="_blank"
        data-testid="reviews-fencing-banner-cta"
        @click="trackPlanUpgrade({ entity_type: entityType, entity_id: entityId, placement })"
        >{{ ctaLabel }}</a
      >
    </template>
    <div class="pl-8">
      <h2 class="mb-1 flex items-center text-headline-xs text-main"><LockIcon class="mr-1 lucide-icon-s" /> {{ headline }}</h2>
      <ul class="fencing-feature-list max-w-lg" @click="onFeatureClick">
        <li v-for="feature in featureList" :key="feature" class="flex items-start py-1 text-body-s text-main">
          <CheckIcon class="mt-1 mr-1 lucide-icon-xs shrink-0 text-icon-primary" /><span v-html="feature" />
        </li>
      </ul>
    </div>
  </MessageBanner>
</template>

<script setup lang="ts">
import { MessageBanner } from '@ramp106/omrjs-core-ui'
import { LockIcon, CheckIcon } from '@ramp106/omrjs-core-ui/icons'
import type { EntityType } from '@ramp106/omrjs-tracking-reviews'

import { trackPlanExplore, trackPlanUpgrade } from '@/services/planCtaTracking'

const props = defineProps<{
  headline: string
  featureList: string[]
  ctaLabel: string
  ctaLink: string
  bannerImage: string
  placement: string
  entityType: EntityType
  entityId: string
}>()

function onFeatureClick(event: MouseEvent) {
  if ((event.target as HTMLElement).closest('a')) {
    trackPlanExplore({ entity_type: props.entityType, entity_id: props.entityId, placement: props.placement })
  }
}
</script>
<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';
.fencing-feature-list :deep(a) {
  @apply underline;
  @apply text-main;
  @apply font-bold;
}

.fencing-feature-list :deep(a:hover) {
  @apply no-underline;
}
</style>
